import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import icons from "../../../assets/images/sprite-other-icons.svg";
import { useDispatch, useSelector } from "react-redux";
import { endpoints } from "../../../api/ApiEndPoints";
import { setbottomMenuContent } from "./cl_bottomMenu";
import { setIsActive, incrementChatOpenCount } from "../../chatbot/cl_ChatbotSlice";
import { setIsSearchBoxOpen, setSearchCtg } from "../../signIn/cl_SignInSlice";
import { setSearchInput } from "../../crashGames/cl_CrashSlice";

const BottomMenu = ({ activeTab, setActiveTab }) => {
  const [activeItem, setActiveItem] = useState(null);
  const [borderX, setBorderX] = useState(0);
  const footerUlRef = useRef(null);
  const dispatch = useDispatch();
  const { staticContent } = useSelector((state) => state?.bottomMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const brandid = endpoints?.fasFasBrandId || 307;

  useEffect(() => {
    if (brandid) dispatch(setbottomMenuContent(brandid));
  }, [dispatch, brandid]);

  const defaultList = [
    { key: "home", labelName: "Home", path: "/", icons: "icon-home", is_active: true },
    { key: "loyalty", labelName: "Loyalty", path: "/loyalty", icons: "icon-loyalty", is_active: true },
    { key: "coins", labelName: "Coins", path: "/fasfascoins", icons: "icon-coins", is_active: true },
    { key: "profile", labelName: "Profile", path: "/profile", icons: "icon-user-avatar", is_active: true },
    { key: "chat", labelName: "Chat", path: "/chat", icons: "icon-chat", is_active: true },
  ];

  const list =
    Array.isArray(staticContent) && staticContent.length > 0
      ? staticContent
          .filter((item) => item?.is_active)
          .map((item) => ({
            key: item.menu_name?.toLowerCase().replace(/\s+/g, ""),
            labelName: item.menu_name,
            path: item.menu_link,
            icons: item.icontags,
            is_active: item.is_active,
          }))
      : defaultList;

  useEffect(() => {
    const index = list.findIndex((item) => item.key === activeTab);
    setActiveItem(index >= 0 ? index : 0);
  }, [activeTab, list]);

  // Recalculate border position whenever active item or container size changes
  useEffect(() => {
    const calculate = () => {
      if (!footerUlRef.current || activeItem === null) return;
      const containerWidth = footerUlRef.current.offsetWidth;
      const itemWidth = containerWidth / list.length;
      const idx = activeItem >= 0 ? activeItem : 0;
      setBorderX(idx * itemWidth + itemWidth / 2 - 35);
    };
    calculate();
    window.addEventListener("resize", calculate);
    return () => window.removeEventListener("resize", calculate);
  }, [activeItem, list.length]);

  return (
    <div id="page-mobile-footer">
      <div className="SB-mobile-footer">
        <ul ref={footerUlRef}>
          {list.map((item, index) => (
            <li
              className={`menu__item ${activeTab === item.key ? "active" : ""}`}
              key={index}
              onClick={() => {
                dispatch(setIsSearchBoxOpen(false));
                dispatch(setSearchCtg(false));
                dispatch(setSearchInput(""));
                if (item.path === "/chat") {
                  dispatch(setIsActive(true));
                  dispatch(incrementChatOpenCount());
                }
                setActiveTab(item.key);
                setActiveItem(index);
                navigate(item.path);
              }}
            >
              {item.is_active && (
                <div className="SB-mobile-footer-item" style={{ cursor: "pointer" }}>
                  <div className="SB-iconSVG">
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use xlinkHref={`${icons}#${item.icons}`} />
                    </svg>
                  </div>
                  <label>{item.labelName}</label>
                </div>
              )}
            </li>
          ))}
        </ul>
        <div className="menu__border" style={{ transform: `translateX(${borderX}px)` }}></div>
      </div>
    </div>
  );
};

export default BottomMenu;
